import React from 'react'

import classNames from 'classnames'
import { useTranslation } from 'react-i18next'

import { useModalContext } from '../context'
import { Button } from '@/Atomic/Molecules/Button'

interface FooterProps {
  children?: React.ReactNode
  className?: string
  onConfirmText?: string
  onCancelText?: string
  onConfirm?: () => void
  onCancel?: () => void
}

export const Footer: React.FC<FooterProps> = ({
  children,
  className,
  onConfirmText,
  onCancelText,
  onConfirm,
  onCancel,
}) => {
  const { onClose, variant } = useModalContext()
  const { t } = useTranslation()

  if (children) {
    return (
      <div className={classNames('o-modal-footer', className)}>{children}</div>
    )
  }

  const primaryText = onConfirmText ?? t('common.confirm')
  const secondaryText = onCancelText ?? t('common.cancel')
  const showCancel = Boolean(onCancel || onCancelText)
  return (
    <div className={classNames('o-modal-footer', 'default-buttons', className)}>
      {showCancel && (
        <Button
          variant="outlined"
          className="cancel-button"
          onClick={onCancel ?? onClose}
        >
          {secondaryText}
        </Button>
      )}
      {onConfirm && (
        <Button
          variant={variant == 'danger' ? 'danger' : 'primary'}
          onClick={onConfirm}
          buttonClassName="confirm-button"
        >
          {primaryText}
        </Button>
      )}
    </div>
  )
}
